import { ThemeButton } from "../../../../molecules/buttons/ThemeButton";
import { ThemeControlZustand } from "../ThemeControlZustand";

export function ThemeButtonZustand() {
  return (
    <ThemeButton>
      <ThemeControlZustand />
    </ThemeButton>
  );
}
